export default __webpack_public_path__ + "static/media/YoungReferent-ilustration.a8f28220.svg";